import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Topnavbar from "./Topnavbar";
import { useMsal } from "@azure/msal-react";
import { getToken, msalInstance } from '../auth/authConfig.js';

const SideNavbar = ({ LoggedinUser }) => {
  const [open, setOpen] = useState(false);
  const [userRole, setUserRole] = useState(localStorage.getItem("GroupName") || '');
  useEffect(()=>{
    const getTokenKeys= localStorage.getItem(`${process.env.REACT_APP_TOKEN}`)
    const jsonCon = getTokenKeys && JSON.parse(getTokenKeys)
    const getIDTokenKey = jsonCon && jsonCon?.idToken[0]
    const getIdToken = getIDTokenKey && localStorage.getItem(`${getIDTokenKey}`)
    const jsonIDtoken = getIdToken  && JSON.parse(getIdToken)
    const secret = jsonIDtoken && jsonIDtoken?.secret
    // localStorage.setItem(
    //   "access-token-storage",
    //   JSON.stringify({ accessToken: secret })
    // );
  
  },[])


  
  const getUserinfo = async () => {
    const url = `${process.env.REACT_APP_SERVER_URL}/api/user/getUserInfoV2`;
    const token = await getToken();
    const maxRetries = 3;
  
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const response = await fetch(url, {
          headers: {
            "oidc-token": token,
            Accept: "application/json",
          },
        });
  
        if (response.ok) { // Check if response status is 200-299 (i.e., successful)
          const json = await response.json();
          const info = json?.user;
          const role = info?.group_name;
          const company = info?.company;
  
          localStorage.setItem("GroupName", role);
          localStorage.setItem("company", company);
  
          setUserRole(role);
          return; // Success, exit function early
        } else {
          // Handle non-OK responses (e.g., 401, 500)
          console.error(`Error: Received status ${response.status}`);
          if (attempt < maxRetries) {
            console.log(`Retrying attempt ${attempt + 1}...`);
            continue; // Retry
          }
          return; // End if non-retryable error
        }
      } catch (err) {
        console.log(`Attempt ${attempt} failed:`, err);
  
        // Retry on network errors or server issues
        if (attempt < maxRetries) {
          console.log(`Retrying attempt ${attempt + 1}...`);
          continue; // Retry
        }
  
        // If all attempts fail, handle the error
        console.error("All retry attempts failed.");
      }
    }
  };
  

  useEffect(()=>{
    getUserinfo()
  },[])

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Topnavbar open={open} Role={userRole} />
      </Box>
    </>
  );
};

export default SideNavbar;
